export enum ANNOUNCEMENTS_PLATFORM_FILTER_ENUM {
  ALL = "ALL",
  UNREAD = "UNREAD",
}

/** Who an announcement is for (MH-376); mirrors the API's AnnouncementScopeType. */
export enum ANNOUNCEMENT_SCOPE_TYPE_ENUM {
  ALL = "ALL",
  BRANCH = "BRANCH",
  DEPARTMENT = "DEPARTMENT",
  TEAM = "TEAM",
  INDIVIDUAL = "INDIVIDUAL",
}
